import { saveInquiry } from '@this/services/inquiry';
const state = {
  showDialog: false,
  showQuote: false,
};

const mutations = {
  setShowDialog(state, bool) {
    state.showDialog = bool;
  },
  setShowQuote(state, bool) {
    state.showQuote = bool;
  },
  setShowVideo(state, bool) {
    state.showVideo = bool;
  },
};

const actions = {
  // 事件
  async clickPrice({ dispatch }) {
    await dispatch('saveInquiry');
    dispatch('changeShowQuote');
  },
  // 步骤
  saveInquiry({ rootState }) {
    const { brands } = rootState.seeCar;
    const { userInfo, mid } = rootState.user;
    const { location } = rootState.city;
    const saveInquiryInfo = {
      brand_id: brands.id,
      brand_name: brands.brand,
      serial_id: brands.car_id,
      serial_name: brands.car_name,
      callName: userInfo.name,
      province: location.province,
      city: location.city,
      amap: location.position,
      mid,
      activity: `${process.env.VUE_APP_H5_KEY}`,
    };
    return saveInquiry(saveInquiryInfo);
  },
  changeShowDialog({ commit, state }, bool) {
    const showDialog = bool ?? !state.showDialog;
    commit('setShowDialog', showDialog);
  },
  changeShowQuote({ commit, state }, bool) {
    const showQuote = bool ?? !state.showQuote;
    commit('setShowQuote', showQuote);
  },
  hideDialog({ dispatch }) {
    dispatch('changeShowDialog');
    dispatch('changeShowQuote');
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
